import { Field } from '#app/components/form/field.tsx'
import { SelectField } from '#app/components/form/select-field.tsx'

import { DISTRIBUTION_SYSTEM_COPY } from '#app/routes/mocra+/_form+/components/distribution-systems/constants.ts'
import { type DistributionSystemDraft } from '#app/routes/mocra+/_form+/components/distribution-systems/types.ts'
import { RECALL_DISTRIBUTION_SYSTEM_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'

type DraftErrors = Partial<Record<keyof DistributionSystemDraft, string>>

type Props = {
	readonly formId: string
	readonly draft: DistributionSystemDraft
	readonly errors: DraftErrors
	readonly onDraftFieldChange: <Field extends keyof DistributionSystemDraft>(
		field: Field,
		value: DistributionSystemDraft[Field],
	) => void
	readonly onSubmit: React.FormEventHandler<HTMLFormElement>
}

export function DistributionSystemForm({
	formId,
	draft,
	errors,
	onDraftFieldChange,
	onSubmit,
}: Props) {
	return (
		<form id={formId} onSubmit={onSubmit}>
			<SelectField
				labelProps={{ children: DISTRIBUTION_SYSTEM_COPY.fields.systemLabel }}
				selectProps={{
					value: draft.system,
					onChange: (event) =>
						onDraftFieldChange(
							'system',
							event.target.value as DistributionSystemDraft['system'],
						),
					onValueChange: (next) =>
						onDraftFieldChange(
							'system',
							next as DistributionSystemDraft['system'],
						),
				}}
				options={RECALL_DISTRIBUTION_SYSTEM_OPTIONS}
			/>
			<Field
				labelProps={{ children: DISTRIBUTION_SYSTEM_COPY.fields.datasetLabel }}
				inputProps={{
					value: draft.dataset,
					onChange: (event) =>
						onDraftFieldChange('dataset', event.target.value),
					type: 'text',
				}}
				errors={errors.dataset ? [errors.dataset] : undefined}
			/>
		</form>
	)
}
